<template>
  <div>
	<div class="data2">
		<div class="data2Right">
			<div class="data2RightTil">内镜诊疗高效化</div>
			<div class="data2RightBox">
				<div class="data2RightBoxFor" v-for="(item,index) in njgfList" :key="index">
					<div class="data2RightBoxForImg">
						<img :src="item.img" />
					</div>
					<div  class="data2RightBoxForName">
						{{item.name}}
					</div>
					<div class="data2RightBoxForCen">
						{{item.cen}}
					</div>
				</div>
			</div>
		</div>
		<div  class="data2Left">
			<div class="swiper-data2-banner">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in list" :key="index">
						<img :src="item.img" />
						<div class="swiper-slide-dw" :class="activeIndex==index?' ':''" style="animation-duration: 1s;">
							<div class="swiper-slide-dw-name">{{item.name}}</div>
							<div class="swiper-slide-dw-cen">
								{{item.cen}}
							</div>
							<div class="swiper-slide-dw-cenen">{{item.cenEn}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		activeIndex:0,
		list:[
			{
				img:require('@/assets/product/njysddlzs.png'),
			},
			{
				img:require('@/assets/product/njysddlzs.png'),
			}
		],
		njgfList:[
			{
				img:require('@/assets/product/data1/txzk.png'),
				name:'图像质控',
				cen:'- 实时监控画面影像，识别图像部位- 起到内镜检查质量控制的警示作用'
			},
			{
				img:require('@/assets/product/data1/zdlt.png'),
				name:'自动留图',
				cen:'- 系统自动分析各部位最清晰的图像和异常视野图像并实时捕捉- 使病例具有更高完整度'
			},
		]
      }
    },
    mounted() {
		let t=this;
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// },
		const mySwiper = new this.$swiper('.swiper-data2-banner', {
			// 方向
			direction: 'horizontal',
			// 自动播放
			autoplay: false,
			slidesPerView: 1,
			on: {
				slideChangeTransitionStart(e){
					  t.activeIndex = this.activeIndex;
				},
				  
			  },
		});
    },	
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.swiper-data2-banner{
	overflow: hidden;
}
.swiper-slide{
	position: relative;
	img{
		width: 45vw;
		height: 600px;
		object-fit: cover;
	}
	video{
		width: 45vw;
		height: 600px;
	}
}
.data2{
	display: flex;
	margin-bottom: 150px;
	width: 100%;
	.data2Left{
		width: 45vw;
		margin-left: 70px;
	}
	.data2Right{ 
		flex: 1;
		padding-Left: 200px;
		.data2RightTil{
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 70px;
		}
		.data2RightBox{
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			.data2RightBoxFor:nth-of-type(2n){
				margin-left: 40px;
			}
			.data2RightBoxFor{
				width: 243px;
				margin-bottom: 58px;
				.data2RightBoxForImg{
					margin-bottom: 39px;
					img{
						width: 70px;
						height: 70px;
					}
				}
				.data2RightBoxForName{
					font-size: 26px;
					
					font-weight: 400;
					color: #000000;
					margin-bottom: 30px;
				}
				.data2RightBoxForCen{
					font-size: 18px;
					
					font-weight: 300;
					color: #000000;
				}
			}
		}
	}
}
</style>
